import React from 'react';

function SampleComponent(props) {
    return (
        <div>
            <h1>Hello! World.</h1>
            <p>このページは{props.text}です。</p> {/* propsの変数を使用 */}
        </div>
    );
}

export default SampleComponent;